interface AdminLoadingStateProps {
  message?: string;
}

const AdminLoadingState = ({ message = "데이터를 불러오는 중입니다." }: AdminLoadingStateProps) => {
  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm px-4 py-10 text-center text-xs text-slate-400">
      <i className="ri-loader-4-line animate-spin mr-1" />
      {message}
    </div>
  );
};

export default AdminLoadingState;
